module.exports = __webpack_public_path__ + "static/media/Purple360Tablet.612aa637.svg";